import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { AppLayoutSecureSideEndDirective } from './partial/side/side-end.directive';
import { ApiAuthService } from '@app/api';

@Injectable({
  providedIn: 'root',
})
export class AppLayoutSecureService {
  public showRecall = false;
  public sideEndOpened = false;
  private _sideEnd?: AppLayoutSecureSideEndDirective;
  private _side?: MatSidenav;

  constructor(
    private _apiAuth: ApiAuthService,
    private _router: Router,
  ) {
    this._router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this._matSidenav?.close());
  }

  private _matSidenav?: MatSidenav;

  set matSidenav(matSidenav: MatSidenav | undefined) {
    this._matSidenav = matSidenav;
  }

  private _matSidenavContent?: MatSidenavContent;

  get matSidenavContent(): MatSidenavContent | undefined {
    return this._matSidenavContent;
  }

  set matSidenavContent(matSidenavContent: MatSidenavContent | undefined) {
    this._matSidenavContent = matSidenavContent;
  }

  setSideEnd(sideEnd: AppLayoutSecureSideEndDirective) {
    this._sideEnd = sideEnd;
  }

  openSideEnd(component: any) {
    this.sideEndOpened = true;
    const viewContainerRef = this._sideEnd?.viewContainerRef;
    if (viewContainerRef) {
      viewContainerRef.clear();

      return viewContainerRef.createComponent<any>(component);
    }
    return null;
  }

  toggleMenu() {
    if (this._apiAuth.hasPermissions('BACKEND_MENU')) {
      return this._matSidenav?.toggle();
    } else {
      return this._router.navigate(['/travel']);
    }
  }

  backToHome() {
    if (this._apiAuth.hasPermissions('BACKEND_MENU')) {
      return this._router.navigate(['/']);
    } else {
      return this._router.navigate(['/travel']);
    }
  }

  logout() {
    this._apiAuth.logout().subscribe(() => this._router.navigate(['/auth']));
  }
}
